export default __webpack_public_path__ + "static/media/flag-palestine,-state-of.b291e099.svg";